import React from 'react'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import Tooltip from "../Tooltip/Tooltip";
import InfoBox from "../InfoBox";
import Checkbox from "../Checkbox";

const RenderPhonenumbers = () => {
  const {
    state,
    dispatch
  } = useStore();
  ;
  const {
    availabilityStore_imp,
    sendSmsExpertPhoneNumber,
    sendSmsToPhoneNumberIds,
    expertPhoneNumbers
  } = state;
  if (!availabilityStore_imp.sendSmsReminders) return null;
  const inputExpertMobilePhoneStyle = {
    marginBottom: '5px',
    marginLeft: ' 6px'
  };

  const onChangeSendSms = (checked, phone) => {
    const phoneId = phone.id;
    const ids = sendSmsToPhoneNumberIds;
    const index = sendSmsToPhoneNumberIds.indexOf(phoneId);

    if (checked) {
      ids.push(phoneId);
      dispatch({
        type: 'UPDATE',
        payload: {
          sendSmsToPhoneNumberIds: ids
        }
      });
      return;
    }

    if (index > -1) {
      ids.splice(index, 1);
      dispatch({
        type: 'UPDATE',
        payload: {
          sendSmsToPhoneNumberIds: ids
        }
      });
    }
  };

  const updateExpertPhoneNumber = (id, value) => {
    const result = expertPhoneNumbers.map(number => {
      if (number.id === id) {
        return { ...number,
          phoneNum: value
        };
      } else {
        return number;
      }
    });
    return dispatch({
      type: 'UPDATE',
      payload: {
        expertPhoneNumbers: result
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "expert-profile__subtitle schedule-calendar__subtitle"
  }, "Expert mobile phones", /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: availabilityStore_imp.staticData.phoneNumberTooltipText
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '20px'
    }
  }, availabilityStore_imp.expertHasNumber && /*#__PURE__*/React.createElement("div", {
    className: "flex-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        sendSmsExpertPhoneNumber: !!e
      }
    }),
    value: sendSmsExpertPhoneNumber,
    label: "Send SMS"
  }), /*#__PURE__*/React.createElement("input", {
    style: inputExpertMobilePhoneStyle,
    value: availabilityStore_imp.expertPhoneNum,
    disabled: true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: "Mobile phone added by expert"
  })), expertPhoneNumbers.length > 0 && expertPhoneNumbers.map((phone, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex-center"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onChange: e => onChangeSendSms(e, phone),
      value: sendSmsToPhoneNumberIds.includes(phone.id),
      label: "Send SMS"
    }), /*#__PURE__*/React.createElement("input", {
      style: inputExpertMobilePhoneStyle,
      onChange: e => updateExpertPhoneNumber(phone.id, e.target.value),
      value: phone.phoneNum,
      key: index,
      placeholder: "Mobile phone..."
    })), phone.hasError && /*#__PURE__*/React.createElement("div", {
      className: "schedule-calendar-modal__input-error"
    }, "Phone number must contain only digits, '+' sign and max length of 16 chars"));
  })), /*#__PURE__*/React.createElement(InfoBox, {
    icon: null
  }, "Reminders will be sent automatically if a number is entered and compliance is in place"));
};

export default RenderPhonenumbers;